export const environment = {
  production: true,
  baseUrl: "",
  baseAvatar: "",
  baseAssetsUrl: "",
  base: "",
  secretKey: 'def00000f3f99257d33857cf24088d239926db31adb6453e1e27548d5cd2bfebc8177f4fd7c2060d8d0956f65204ab8ee1c9be29b4ed01a3e8020cf7ee792721bc7607b5'
};
